import React from 'react';
import { Button } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import 'bootstrap/dist/css/bootstrap.min.css';

const CardComponent = ({ Vendor, VendorKitItem, items, EditCard, DeleteCard }) => (
  <div
    className="card shadow-lg p-4"
    style={{
      maxWidth: '350px',
      minWidth: '350px',
      borderRadius: '20px',
      background: '#fff',
      boxShadow: '8px 8px 16px #bebebe, -8px -8px 16px #ffffff',
      margin: '20px auto',
    }}
  >
    <h4 style={{ color: '#333', fontWeight: 'bold' }}>{Vendor}</h4>
    <p style={{ color: '#555' }}>Vendor KitItem: <span style={{ fontWeight: 'bold' }}>{VendorKitItem}</span></p>
    {/* Table Section */}
    <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
      <table className="table table-sm table-bordered text-center">
        <thead style={{ background: '#f8f9fa' }}>
          <tr>
            <th style={{ fontSize: '14px' }}>Item ID</th>
            <th style={{ fontSize: '14px' }}>Qty</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td style={{ fontSize: '13px' }}>{item.itemId}</td>
              <td style={{ fontSize: '13px' }}>{item.qty}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    {/* Buttons */}
    <div className="d-flex justify-content-between mt-3">
      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={<Edit />}
        style={{ borderRadius: '10px', boxShadow: '3px 3px 6px #bebebe' }}
        onClick={EditCard}
      >
        Edit
      </Button>
      <Button
        variant="outlined"
        color="error"
        size="small"
        startIcon={<Delete />}
        style={{
          borderRadius: '10px',
          background: '#fff',
          boxShadow: '3px 3px 6px #bebebe',
        }}
        onClick={DeleteCard}
      >
        Delete
      </Button>
    </div>
  </div>
);

export default CardComponent;
